import React from 'react'


export default function TermsCondition() {
  const bannerstyle = {
    margin: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    paddingBottom: '3%'
  }
  
  return (
    <div>
      
        <section className="banner" style={bannerstyle}>
           <div className="container-fluid">
               <div className="row">
                   <div className="col-md-12 p-0">
                       <div className="sub-banner">
                          <img src="/assets/img/banner-tnc.jpg" className="d-block w-100" alt="..." />
                          
  
                       </div>
                   </div>
               </div>
           </div>
           <div className="container aboutHead">
                <div className="row">
                    <div className="col-md-12">
                         <h1>Terms & Conditions</h1>
                    </div>
                </div>
           </div>
       </section>

<section className="privacy"> 
      <div className="container">
        <div className='row'>
          <div className='col-md-12 my-4'>
            <p>
    Welcome to <strong>Unlock Destinations</strong>. By booking a trip with us, you agree to the terms outlined below. These terms govern the relationship between Unlock Destinations and the client. Please read them carefully before proceeding with any bookings.
  </p>

  <h2>Company Information</h2>
  <p><strong>Legal Name:</strong> Unlock Destinations</p>
  <p><strong>Registered Office:</strong> B-45, Block L, Lajpat Nagar II, Lajpat Nagar, New Delhi, Delhi 110024</p>

  <h2>General Terms</h2>
  <ul>
    <li><strong>Booking Confirmation:</strong> A booking is confirmed only after receipt of the booking amount as specified in the invoice.</li>
    <li><strong>Payments:</strong> Payment schedules and deadlines will be communicated at the time of booking. Late payments may result in cancellation.</li>
    <li><strong>Cancellations and Refunds:</strong> Cancellations are subject to the Cancellation Policy outlined separately. Refunds will be processed after deducting applicable charges.</li>
    <li><strong>Travel Documents:</strong> Clients must ensure that all travel documents (e.g., passports, visas) are valid. Unlock Destinations is not responsible for delays or cancellations due to invalid documents.</li>
    <li><strong>Health and Safety:</strong> Clients must disclose any medical conditions. Unlock Destinations is not liable for incidents arising from undisclosed health issues.</li>
    <li><strong>Force Majeure:</strong> Unlock Destinations is not liable for cancellations or changes caused by events beyond our control, such as natural disasters, political unrest, or pandemics.</li>
  </ul>

  <h2>Liabilities and Responsibilities</h2>
  <ul>
    <li>Unlock Destinations acts as an intermediary between clients and service providers (hotels, airlines, etc.) and is not liable for disruptions caused by third parties.</li>
    <li>Clients are responsible for complying with all visa regulations, entry requirements, customs rules, and laws of the destination country.</li>
    <li>Unlock Destinations will not be held liable if entry is denied or travel is disrupted due to non-compliance with legal or immigration requirements.</li>
  </ul>

  <h2>Payment Terms</h2>

  <h3>Booking Confirmation</h3>
  <p>
    To secure your booking, a specified deposit must be paid at the time of booking. All quotes are tentative and subject to availability and pricing at the time of final payment. Any changes to your booking will be communicated within 72 hours (excluding Sundays and public holidays).
  </p>

  <h3>Payment Policy</h3>
  <p>
    Payments must be made as per the Payment Policy (Annexure A). Accepted payment methods include credit/debit cards, bank transfers, and online payment gateways. Payments must be made in INR, based on the prevailing Rate of Exchange (ROE) on the date of final payment.
  </p>

  <h3>Failure to Pay</h3>
  <p>
    Failure to clear payments by the due date may result in cancellation of services at our sole discretion.
  </p>

  <h3>Government Compliance</h3>
  <p>
    As per current Indian government regulations, a 5% TCS is applicable on international travel bookings up to ₹10 lakhs in a financial year. For transactions of ₹10 lakhs or more, a 20% TCS will apply.
  </p>

  <h3>Forfeiture Clause</h3>
  <p>
    Any cash deposits made without the knowledge of Unlock Destinations into its bank accounts against a booking will be forfeited.
  </p>

  <h2>Annexure A: Payment Details</h2>

  <h3>Booking Confirmation Payment</h3>
  <ul>
    <li><strong>Short-Haul Trips:</strong> 30% advance at time of booking.</li>
    <li><strong>Long-Haul Trips:</strong> 30% advance at time of booking.</li>
    <li><strong>Balance Payment:</strong> 30 days before departure (short-haul) and 50 days before departure (long-haul).</li>
    <li><strong>Late Payments:</strong> 5% per day late fee on outstanding amount.</li>
    <li><strong>Short-Haul Trips:</strong> Cancellation after 7 days of delay.</li>
    <li><strong>Long-Haul Trips:</strong> Cancellation after 10 days of delay.</li>
  </ul>

  <h3>Payment Methods</h3>
  <ul>
    <li>Bank Transfer, Credit/Debit Cards, and UPI.</li>
    <li>All payments must be made in INR unless otherwise specified.</li>
    <li>Additional charges (e.g., foreign transaction fees) are borne by the client.</li>
  </ul>

  <h3>Refunds and Adjustments</h3>
  <ul>
    <li>Refunds processed within 30 business days.</li>
    <li>Flights, taxes, and permits may be non-refundable.</li>
    <li>Expedited processing fees may apply within 10 days of departure.</li>
  </ul>

  <h2>Annexure B: Cancellation Policy</h2>

  <div class="note">
    <strong>Note:</strong> Flight cancellations will be governed by the respective airline’s fare rules.
  </div>

  <ul>
    <li>Any-time cancellation: ₹5000 per person for hotel/land package + actual supplier cancellation charges + ₹1000 per person airline service fee + airline charges.</li>
    <li>45 days before departure: 30% of total invoice.</li>
    <li>40 days before departure: 60% of total invoice.</li>
    <li>35 days before departure: 85% of total invoice.</li>
    <li>Within 30 days of departure: 100% of total invoice.</li>
    <li>No-show or in-stay cancellation: 100% of total invoice.</li>
  </ul>

  <h3>Special Conditions</h3>
  <ul>
    <li>Non-refundable services will be charged in full regardless of cancellation date.</li>
    <li>Peak season and festival bookings may attract stricter cancellation terms.</li>
  </ul>

  <h3>Partial Cancellations</h3>
  <p>
    For group bookings, partial cancellations will result in cost recalculation for remaining travelers.
  </p>

  <h3>Changes by Unlock Destinations</h3>
  <ul>
    <li>Clients will be notified at the earliest in case of major changes.</li>
    <li>Clients may accept revised plans or choose alternatives of similar standard (price adjustments may apply).</li>
  </ul>

  <h3>Refund Timelines</h3>
  <ul>
    <li>Refunds usually processed within 3-4 working days and up to 21 working days in some cases.</li>
    <li>Refunds to original payment method or via bank transfer within 7-15 working days.</li>
    <li>Refunds for non-operational activities within 30 days.</li>
    <li>Complimentary activities are not refundable.</li>
    <li><strong>Non-Refundable Booking Amount:</strong> The initial token/booking amount is strictly non-refundable.</li>
  </ul>

  <h2>Annexure C: Group Bookings</h2>
  <ul>
    <li>Reduction in group size may alter pricing or incur extra charges.</li>
    <li>Groups of 10 or more must confirm final numbers 30 days prior to departure.</li>
    <li>A designated group leader will coordinate with Unlock Destinations.</li>
  </ul>

  <h2>Annexure D: Destination-Specific Terms</h2>

  <h3>Adventure Destinations</h3>
  <p>
    Weather-dependent activities may be rescheduled or cancelled. Refunds will follow standard terms.
  </p>

  <h3>International Destinations</h3>
  <p>
    Clients must comply with visa and entry requirements. Unlock Destinations is not responsible for denial of entry or deportation due to non-compliance.
  </p>

  <h3>Special Events and Peak Seasons</h3>
  <p>
    Festival and holiday bookings may have stricter cancellation policies which will be communicated at the time of booking.
  </p>
  


</div>

   </div> 
    </div>
    </section>
            

    </div>
  )
}
